import { getAppSetting } from '../ApplicationSettings';
import AUTHSETTINGS from './AuthSettings';
import 'regenerator-runtime/runtime';

import { UserManager, WebStorageStateStore, Log } from 'oidc-client';

export default class AuthService {
  UserManager;
  PUBLICURL;
  constructor() {
    const { IDENTITY_CONFIG, METADATA_OIDC } = AUTHSETTINGS;

    this.PUBLICURL = location.origin;
    this.UserManager = new UserManager({
      ...IDENTITY_CONFIG,
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      metadata: {
        ...METADATA_OIDC
      }
    });

    // Logger
    Log.logger = console;
    Log.level = Log.ERROR;

    this.UserManager.events.addUserLoaded((user) => {
      this.setUserInfo({
        accessToken: user.access_token,
        idToken: user.id_token,
        userName: user.profile.name,
        userId: user.profile.sub,
        userEmail: user.profile.preferred_username
      });
      if (window.location.href.indexOf('signin-oidc') !== -1) {
        this.navigateToScreen();
      }
    });
    this.UserManager.events.addSilentRenewError((e) => {
      console.debug('silent renew error', e.message);
    });

    this.UserManager.events.addAccessTokenExpired(() => {
      console.debug('token expired');
      this.signinSilent();
    });

    this.UserManager.events.addUserSignedOut(() => {
      this.UserManager.clearStaleState();
      window.location.replace(this.PUBLICURL);
    });
  }

  signinRedirectCallback = () => {
    this.UserManager.signinRedirectCallback()
      .then(() => {
        console.debug('signin redirectcallback');
      })
      .catch((err) =>
        /* TODO: we probably want to throw and catch in 
        error boundry, and take appropriate measures, 
        in the long run (if possible) */
        console.debug(err)
      );
  };

  getUser = async () => {
    const user = await this.UserManager.getUser();

    if (!user) {
      return await this.UserManager.signinRedirectCallback();
    }
    return user;
  };

  setUserInfo = (authResult) => {
    localStorage.setItem('userId', authResult.userId);
    localStorage.setItem('userName', authResult.userName);
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('userEmail', authResult.userEmail);
  };

  signinRedirect = (lastKnownPath?: string) => {
    localStorage.setItem(
      'redirectUri',
      lastKnownPath
        ? lastKnownPath
        : window.location.pathname + window.location.search
    );
    this.UserManager.signinRedirect();
  };

  navigateToScreen = () => {
    const redirectUri = !!localStorage.getItem('redirectUri')
      ? localStorage.getItem('redirectUri')
      : '/';
    window.location.replace(redirectUri);
  };

  isAuthenticated = () => {
    const key = `oidc.user:${getAppSetting(
      'REACT_APP_AUTH_URL'
    )}/:${getAppSetting('REACT_APP_IDENTITY_CLIENT_ID')}`;
    const oidcStorage = JSON.parse(localStorage.getItem(key));
    return !!oidcStorage && !!oidcStorage.access_token;
  };

  signinSilent = () => {
    this.UserManager.signinSilent()
      .then(() => {
        console.debug('signed in');
      })
      .catch((err) => {
        if (err.message === 'invalid_grant') {
          this.UserManager.clearStaleState();
          localStorage.clear();
          this.signinRedirect();
        }
        console.debug(err);
      });
  };
  signinSilentCallback = () => {
    this.UserManager.signinSilentCallback();
  };

  createSigninRequest = () => {
    return this.UserManager.createSigninRequest();
  };

  logout = () => {
    this.UserManager.signoutRedirect({
      id_token_hint: localStorage.getItem('id_token')
    }).then(() => {
      this.UserManager.clearStaleState();
      localStorage.clear();
    });
  };

  signoutRedirectCallback = () => {
    this.UserManager.signoutRedirectCallback().then(() => {
      localStorage.clear();
      window.location.replace(this.PUBLICURL);
    });
    this.UserManager.clearStaleState();
  };
}
